import { FEE_MODE } from 'Data/constants.js'

export function getView(is_acknowledged, fee_mode, has_changes) {
  return (
    is_acknowledged &&
    !has_changes &&
    [FEE_MODE.PLATFORM_FEE, FEE_MODE.SURCHARGE].includes(fee_mode)
  )
}
